import $ from "jquery";
import _ from "lodash";

const d3 = require("d3");
/**
 * Old photo map: renders colored map based on photos.
 */
const photoMap = {
  // will be set on load
  countByState: {},

  /**
   * @param  {string} state
   * @return {string}
   */
  getStateAbbreviation(state) {
    const states = {
      Alabama: "AL",
      Alaska: "AK",
      "American Samoa": "AS",
      Arizona: "AZ",
      Arkansas: "AR",
      California: "CA",
      Colorado: "CO",
      Connecticut: "CT",
      Delaware: "DE",
      "District Of Columbia": "DC",
      "Federated States Of Micronesia": "FM",
      Florida: "FL",
      Georgia: "GA",
      Guam: "GU",
      Hawaii: "HI",
      Idaho: "ID",
      Illinois: "IL",
      Indiana: "IN",
      Iowa: "IA",
      Kansas: "KS",
      Kentucky: "KY",
      Louisiana: "LA",
      Maine: "ME",
      "Marshall Islands": "MH",
      Maryland: "MD",
      Massachusetts: "MA",
      Michigan: "MI",
      Minnesota: "MN",
      Mississippi: "MS",
      Missouri: "MO",
      Montana: "MT",
      Nebraska: "NE",
      Nevada: "NV",
      "New Hampshire": "NH",
      "New Jersey": "NJ",
      "New Mexico": "NM",
      "New York": "NY",
      "North Carolina": "NC",
      "North Dakota": "ND",
      "Northern Mariana Islands": "MP",
      Ohio: "OH",
      Oklahoma: "OK",
      Oregon: "OR",
      Palau: "PW",
      Pennsylvania: "PA",
      "Puerto Rico": "PR",
      "Rhode Island": "RI",
      "South Carolina": "SC",
      "South Dakota": "SD",
      Tennessee: "TN",
      Texas: "TX",
      Utah: "UT",
      Vermont: "VT",
      "Virgin Islands": "VI",
      Virginia: "VA",
      Washington: "WA",
      "West Virginia": "WV",
      Wisconsin: "WI",
      Wyoming: "WY",
    };
    return states[state];
  },

  /**
   * When user clicks anywhere on map.
   * If clicked a state, zoom into the state, and toggle photos for that state.
   * Otherise, zoom out.
   *
   * @param  {object=} d: optional details about item clicked.
   */
  clickMap(event, d) {
    const self = this;
    let x;
    let y;
    let k;
    let title;
    let state;

    if (d && this.centered !== d) {
      const centroid = this.path.centroid(d);
      x = centroid[0];
      y = centroid[1];
      k = 4;
      this.centered = d;
      state = d.properties.abbreviation;
      title = `${d.properties.name} <small>(${d.properties.count})</small>`;
      if (d.properties.count === 0) {
        $(".none").find("span").text(state);
        $(".none").show();
      } else {
        $(".none").hide();
      }
    } else {
      x = this.width / 2;
      y = this.height / 2;
      k = 1;
      this.centered = null;
      title = "All States";
      state = "all";
      $(".none").hide();
    }

    $(".now_viewing span").html(title);
    this.togglePhotosByState(state);

    this.svg
      .select("#states")
      .selectAll("path")
      .classed("active", self.centered && ((d) => d === self.centered));

    this.svg
      .select("#states")
      .transition()
      .duration(1000)
      .attr(
        "transform",
        `translate(${this.width / 2},${
          this.height / 2
        })scale(${k})translate(${-x},${-y})`
      )
      .style("stroke-width", `${1.5 / k}px`);
  },

  /**
   * Toggle visibility of photos per state.
   *
   * @param  {string} state
   */
  togglePhotosByState(state) {
    if (state !== "all") {
      $(".photo-list__item").hide();
      $(`.photo-list__item--state-${state}`).show();
    } else {
      $(".photo-list__item").show();
    }
  },

  /**
   * Class string based on count per state.
   *
   * @param  {number} count
   * @return {string}
   */
  getClassByCount(count) {
    if (count <= 0) {
      return "empty";
    }

    if (count > 30) {
      return "huge";
    }
    if (count > 20) {
      return "large";
    }
    if (count > 10) {
      return "medium";
    }
    return "small";
  },

  /**
   * Get count set for a given state
   * @param  {string} state
   * @return {number}
   */
  getCountByState(state) {
    return this.countByState[state] || 0;
  },

  /**
   * Store per state level counts
   */
  setCountByState() {
    const self = this;
    this.photos.forEach((photo) => {
      if (photo.state !== "") {
        if (typeof self.countByState[photo.state] !== "undefined") {
          self.countByState[photo.state] += 1;
        } else {
          self.countByState[photo.state] = 1;
        }
      }
    });
  },

  /**
   * Clear map contents
   */
  clearMap() {
    const div = document.getElementById("map");
    while (div.firstChild) {
      div.removeChild(div.firstChild);
    }
  },

  /**
   * Build and render map of states.
   * Inspired by: http://bl.ocks.org/michellechandra/0b2ce4923dc9b5809922
   */
  drawMap() {
    const self = this;
    this.width = this.$map.width();
    this.height = this.$map.height();
    this.centered = null;

    // be dumb and assume we've already rendered map. clear it.
    this.clearMap();

    // D3 Projection
    const projection = d3
      .geoAlbersUsa()
      .translate([this.width / 2, this.height / 2]) // translate to center of screen
      .scale([900]); // scale things down so see entire US

    // Define path generator
    this.path = d3
      .geoPath() // path generator that will convert GeoJSON to SVG paths
      .projection(projection); // tell path generator to use albersUsa projection

    const mapWidth = 970;

    const svg = d3
      .select("#map")
      .append("svg")
      .attr("width", this.width)
      .attr("height", this.height);

    svg
      .append("rect")
      .attr("class", "background")
      .attr("width", this.width)
      .attr("height", this.height)
      .on("click", self.clickMap.bind(self));

    svg.append("g").attr("id", "states");

    if (this.width > mapWidth) {
      svg
        .select("#states")
        .attr("transform", `translate(${(this.width - mapWidth) / 2})`);
    }

    svg
      .select("#states")
      .selectAll("path")
      .data(this.mapMetadata.features)
      .enter()
      .append("path")
      .attr(
        "class",
        (d) =>
          `state ${self.getClassByCount(d.properties.count)} ${
            d.properties.abbreviation
          }`
      )
      .attr("d", this.path)
      .on("click", self.clickMap.bind(self));

    this.svg = svg;
  },

  /**
   * Takes the json from the state source file and packages in any additional data we need, such
   * as the state abreviation (and soon to come: photo count, etc)
   */
  setStateData() {
    const self = this;
    this.mapMetadata.features.forEach((meta) => {
      const state = self.getStateAbbreviation(meta.properties.name);
      meta.properties.abbreviation = state;
      meta.properties.count = self.getCountByState(state);
    });
  },

  /**
   * Render out a map of states colored to show how many
   * photos exist for each one.
   */
  init() {
    const $photoData = $("#map-photos");
    const $mapData = $("#map-metadata");
    this.$map = $("#map");
    this.photos = JSON.parse($photoData.val());
    this.mapMetadata = JSON.parse($mapData.val());
    this.setCountByState();
    this.setStateData();
    this.drawMap();

    const self = this;
    $(".zoom_out").on("click", (event) => {
      event.preventDefault();
      self.clickMap();
    });

    window.addEventListener("resize", _.debounce(self.drawMap.bind(self), 100));
  },
};

document.addEventListener("DOMContentLoaded", (e) => {
  photoMap.init();
});
